import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetailPage from "../pages/articles/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;